const UNCHECKED = 0;
const INTERMEDIATE = -1;
const CHECKED = 1;

export { UNCHECKED, INTERMEDIATE, CHECKED };
